import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { VIDEO_SEARCH_CONVERTER_TOKEN, VideoSearchConverter } from './video-search.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        videoSearchFeature: {
          module: () => import('./video-search.module').then((m) => m.VideoSearchModule),
          cmsComponents: ['video_search'],
        },
      }
    }),
    {
      provide: VIDEO_SEARCH_CONVERTER_TOKEN,
      useClass: VideoSearchConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        video_search: VIDEO_SEARCH_CONVERTER_TOKEN
      },
      multi: true
    },
  ]
})
export class VideoSearchFeatureModule {}
